export const BASE_KEY = 'CUSTOMER_AVATARS';

export const customerAvatarsKeys = {
  all: () => [BASE_KEY] as const,
};
